import { useEffect, useRef, useState } from "react";

const PHASES = [["Inhala", 5, 1], ["Exhala", 5, 0.7]];
const CYCLES = 6;

export const useBreath = () => {
  const [state, setState] = useState({ running: false, phase: -1, cycle: 0, done: false });
  const timer = useRef(null);

  const stop = (done = false) => {
    clearTimeout(timer.current); timer.current = null;
    setState({ running: false, phase: -1, cycle: 0, done });
  };
  const start = () => {
    let cycle = 0, p = 0;
    const step = () => {
      if (cycle >= CYCLES) return stop(true);
      setState({ running: true, phase: p, cycle, done: false });
      timer.current = setTimeout(() => { p++; if (p >= PHASES.length) { p = 0; cycle++; } step(); }, PHASES[p][1] * 1000);
    };
    step();
  };
  useEffect(() => () => clearTimeout(timer.current), []);
  return { ...state, start, stop };
};

export const BreathSteps = ({ phase }) => (
  <div className="steps-b">
    {PHASES.map(([name, sec], i) => (
      <span key={name} className={phase === i ? "on" : ""}><b>{sec}</b>{name}</span>
    ))}
  </div>
);

export const BreathOrb = ({ b }) => {
  const ph = PHASES[b.phase];
  const style = ph
    ? { transitionDuration: `${ph[1]}s`, transform: `scale(${ph[2]})` }
    : { transitionDuration: "1.2s", transform: "scale(.7)" };
  return (
    <div className="orb-stage" aria-live="polite">
      <div className="orb-ring" /><div className="orb-ring" />
      <div className="orb" style={style} />
      <div className="orb-label">
        <b data-testid="breath-label">{ph ? ph[0] : b.done ? "Bien hecho" : "Cuando quieras"}</b>
        <small data-testid="breath-count">{ph ? `Ciclo ${b.cycle + 1} de ${CYCLES} · ${ph[1]} s` : b.done ? "Cómo te sientes ahora" : `${CYCLES} ciclos · ${CYCLES * PHASES.reduce((a, x) => a + x[1], 0)} s`}</small>
      </div>
    </div>
  );
};

export const BreathButton = ({ b }) => (
  <button className="btn btn-primary mag" data-testid="breath-start-button" onClick={() => (b.running ? b.stop() : b.start())}>
    {b.running ? "Parar" : "Empezar a respirar"}
  </button>
);
